<template>
    <div class="fila">
        <div class="group-col" v-if="locacion_solicitud === 1 && forma_solicitud === 1">
            <div class="column-title first row-number" :class="{'row-red': (error_prop && !mostrar_cargar)}">
              <div class="opt-hover">
                <v-icon color="black" @click="$emit('del',_id)">mdi-minus</v-icon>   
              </div>  
              <div v-if="mostrar_cargar">
                    <v-progress-circular
                    indeterminate
                    color="primary"
                    ></v-progress-circular>
                   
              </div>
              <div v-if="error_prop && !mostrar_cargar">
                <v-icon color="white">mdi-cancel</v-icon>
              </div>
              <div v-if="!mostrar_cargar  && !error_prop">
                {{idx}}
              </div>
              
              
            </div>
            <div class="column">
                <v-select
                v-model="forma_solicitud"
                :items="values_forma_solicitud"
                item-value="id"
                item-text="value"
                v-if="locacion_solicitud === 1"
                ></v-select>
            </div>
            <v-form ref="form" class="form">
            <div class="column">
                
                    <v-file-input
                    accept="text/xml"
                    v-model="solicitud.archivo"
                    name="XML Factura"
                    :rules="[
                    (value) =>
                    !value || value.size > 0 || 'Suba un archivo valido',
                    ]"
                    required
                    @change="analize_xml"
                    ></v-file-input>

  

                    <div v-if="false">
                      <p class="red--text">{{ texto_error }}</p>
                    </div>    

                
            </div>
            <div class="column">
                <v-file-input
                accept="application/pdf"
                v-model="solicitud.anexo_cfdi"
                name="PDF Comprobación"
                :rules="[
                (value) =>
                !value || value.size > 0 || 'Suba un archivo valido',
                ]"
                required
                ></v-file-input>
            </div>
            <div class="column">
                <v-text-field
                v-model="fecha_formated"
                data-date-format="dd-mm-yyyy"
                readonly
                filled
                ></v-text-field>
            </div>
            <div class="column">
              <v-text-field
                v-model="solicitud.numero_factura"
                readonly
                filled
                required
                ></v-text-field>
            </div>
            <div class="column">
                <v-text-field
                v-model="solicitud.total"
                readonly
                filled
                ></v-text-field>
            </div>
            <div class="column">
                <v-select
                :items="divisas"
                item-text="divisa"
                item-value="id_divisa"
                v-model="solicitud.id_divisa"
                readonly
                filled
                ></v-select>
            </div>
            <template v-if="foreign_ex==false && add_empty">
              <div class="column void"></div>
              <div class="column void"></div>
            </template>
            <div class="column">
                <v-select
                :items="cuentas"
                item-text="nombre_cuenta"
                item-value="id_cuenta"
                v-model="solicitud.id_cuenta"
                @change="show_anexo_form"
                :rules="[(v) => !!v || 'Seleccione una cuenta']"
                required
                ></v-select>
            </div>
            <div class="column">
                <v-textarea
                v-model="solicitud.descripcion"
                name="Descripción"
                readonly
                filled
                no-resize
                rows="2"
                ></v-textarea>
            </div>
            <div class="column" v-if="requiere_descripcion">
                <v-textarea
                  prepend-icon="mdi-text-subject"
                  v-model="solicitud.comentarios"
                  name="Comentario"
                  no-resize
                  :rules="[(v) => !!v || 'Escriba una descripción']"
                  required
                rows="2"
                ></v-textarea>
          </div>
          <div v-else class="column void"></div>
            
          <template v-if="propina==false && add_empty_tip">
            <div class="column void"></div>
            <div class="column void"></div>
            <div class="column void"></div>
            <div class="column void"></div>
          </template> 
            <template v-if="propina">
                <div class="column">
                    <v-file-input
                    accept="application/pdf, image/png, image/jpeg"
                  
                    v-model="solicitud.archivo_propina"
                    ></v-file-input>
                </div>
                <div class="column">
                    <v-text-field
                    type="number"
                    v-model="solicitud.propina"
                   
                    
                    ></v-text-field>
                </div>
                <div class="column">
                    <v-textarea
                    v-model="solicitud.descripcion_propina"
                    
                    
                    no-resize
                    rows="2"
                    ></v-textarea>
                </div>
                <div class="column">
                    <v-textarea
                    v-model="solicitud.comensales_propina"
                    
                    
                    no-resize
                    rows="2"
                    ></v-textarea>
                </div>
            </template>
          </v-form>
        </div> <!-- fin del group -->


        <div
        v-if=" locacion_solicitud === 2 || (locacion_solicitud === 1 && forma_solicitud === 2)"
        class="group-col">
            <div class="column-title first row-number" :class="{'row-red': (error_prop && !mostrar_cargar)}">
              <div class="opt-hover">
                <v-icon color="black" @click="$emit('del',_id)">mdi-minus</v-icon>   
              </div> 
              <div v-if="mostrar_cargar" class="bg-white">
                    <v-progress-circular
                    indeterminate
                    color="primary"
                    ></v-progress-circular>
                   
              </div>
              <div v-if="error_prop">
                <v-icon color="white">mdi-cancel</v-icon>
              </div>
              <div v-if="!mostrar_cargar  && !error_prop">
                {{idx}}
              </div>
            </div>
            <div class="column">
                <v-select
                v-model="forma_solicitud"
                :items="values_forma_solicitud"
                item-value="id"
                item-text="value"
                v-if="locacion_solicitud === 1"
                ></v-select>
            </div>
            <div class="column void">

            </div>
            <v-form ref="form_pdf" class="form">
            <div class="column">
                <v-file-input
                accept="application/pdf, image/png, image/jpeg"
                v-model="solicitud_sin_factura.archivo"
                name="PDF Comprobación"
                :rules="[
                (value) => !value || value.size > 0 || 'Suba un archivo valido',
                ]"
                required
                ></v-file-input>
            </div>
            <div class="column">
                <v-menu
                v-model="menu2"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                max-width="290px"
                min-width="290px"
                >
                    <template v-slot:activator="{ on }">
                        <v-text-field
                        v-model="sin_fecha_formated"
                        readonly
                        v-on="on"
                        data-date-format="dd-mm-yyyy"
                        :rules="[(v) => !!v || 'Seleccione una fecha']"
                        required
                        ></v-text-field>
                    </template>
                    <v-date-picker
                    :max="new Date().toISOString().slice(0, 10)"
                    v-model="solicitud_sin_factura.fecha_solicitud"
                    no-title
                    @input="menu2 = false"
                    ></v-date-picker>
                </v-menu>
            </div>
            <div class="column">
                <v-text-field
                v-model="solicitud_sin_factura.numero_factura"
                name="Numero Factura"
                :rules="[(v) => !!v || 'Escriba el número de factura']"
                required
                ></v-text-field>
            </div>
            <div class="column">
                <v-text-field
                type="number"
                v-model="solicitud_sin_factura.total"
                :rules="[(v) => !!v || 'Escriba el total']"
                name="Importe"
                required
                ></v-text-field>
            </div>
            <div class="column">
                <v-select
                :items="divisas"
                item-text="divisa"
                item-value="id_divisa"
                v-model="solicitud_sin_factura.id_divisa"
                :rules="[(v) => !!v || 'Seleccione una divisa']"
                @change="update_exchange"
                required
                ></v-select>
            </div>
            <template v-if="foreign_ex==false && add_empty">
              <div class="column void"></div>
              <div class="column void"></div>
            </template>
            <template v-if="foreign_ex">
                <div class="column">
                  <v-text-field
                  type="number"
                  v-model="solicitud_sin_factura.monto_cambio"
                  :rules="[(v) => !!v || 'Escriba el monto de cambio']"
                  required
                  ></v-text-field>
                </div>
                <div class="column">
                  <v-text-field 
                  type="number" 
                  disabled
                  :value="solicitud_sin_factura.monto_cambio*solicitud_sin_factura.total"
                  >
                  </v-text-field>
                </div>
            </template>

            <div class="column">
                <v-select
                :items="cuentas"
                item-text="nombre_cuenta"
                item-value="id_cuenta"
                v-model="solicitud_sin_factura.id_cuenta"
                @change="necesita_propina"
                :rules="[(v) => !!v || 'Seleccione una cuenta']"
                required
                ></v-select>
            </div>
            <div class="column">
              <v-textarea
                    prepend-icon="mdi-text-subject"
                    v-model="solicitud_sin_factura.descripcion"
                    :rules="[(v) => !!v || 'Escriba una descripción']"
                    name="Descripción"
                    required
                    no-resize
                    rows="2"
                    ></v-textarea>
            </div>
            <div v-if="requiere_descripcion_pdf" class="column"> 
                <v-textarea
                v-model="solicitud_sin_factura.comentarios"
                name="Comentarios"
                no-resize
                rows="2"
                ></v-textarea>
            </div>
            <div v-else class="column void">

            </div>
            <template v-if="propina_pdf==false && add_empty_tip">
              <div class="column void"></div>
              <div class="column void"></div>
              <div class="column void"></div>
              <div class="column void"></div>
            </template>

            <template v-if="propina_pdf">
                <div class="column">
                    <v-file-input
                    accept="application/pdf, image/png, image/jpeg"
            
                    v-model="solicitud_sin_factura.archivo_propina"
                    ></v-file-input>
                </div>
                <div class="column">
                    <v-text-field
                    type="number"
                    prepend-icon="mdi-currency-usd"
                  
                    v-model="solicitud_sin_factura.propina"
                    ></v-text-field>
                </div>
                <template v-if="descripcion_propina_pdf">
                    <div class="column">
                        <v-textarea
                        prepend-icon="mdi-text-subject"
                       
                        v-model="solicitud_sin_factura.descripcion_propina"
                        no-resize
                        rows="2"
                        ></v-textarea>
                    </div>
                    <div class="column">
                        <v-textarea
                        prepend-icon="mdi-text-subject"
                      
                        v-model="solicitud_sin_factura.comensales_propina"
                        no-resize
                        rows="2"
                        ></v-textarea>
                    </div>
                </template>
                <!-- <div class="column" v-if="
                locacion_solicitud === 2 ||
                (locacion_solicitud === 1 && forma_solicitud === 2)
                ">
                    
                </div> -->
            </template>
          </v-form>
        </div>
    </div> <!--fin de fila -->
</template>
<script>
import axios from "axios"
export default {
    props: {

        _id: {
          type: String,
          default: null
        },
        deudor:{
          type: String,
          default: null
        },
        deudor_original:{
          type: String,
          default: null
        },        
        error_prop: {
            type: Boolean,
            default: false
        },
        values_forma_solicitud: {
            type: Array,
            default: () => {[]}
        },
        divisas: {
            type: Array,
            default: () => {[]}
        },
        cuentas: {
            type: Array,
            default: () => {[]}
        },
        idx: {default: 0},
        add_empty: {
          type: Boolean,
          default: false
        },
        add_empty_tip: {
          type: Boolean,
          default: false
        }
        
    },
    data: () =>{
        return {
            locacion_solicitud: 1,
            forma_solicitud: 1,
            solicitud: {},
            mostrar_cargar: false,
            mostrar_error_xml: false,
            texto_error: "",
            is_waiting: false,
            propina: false,
            solicitud_sin_factura: {},
            menu2: false,
            requiere_descripcion_pdf: false,
            descripcion_propina_pdf: false,
            propina_pdf: false,
            propina_column: false,
            foreign_ex: false,
            fecha_formated: ""
        }
    },
    mounted: function(){
      this.solicitud_sin_factura.id_divisa=45
    },
    methods: {

        analize_xml: function(){
            try {
                if (this.solicitud.archivo !== null) {
        if (
          this.solicitud.archivo !== undefined &&
          this.solicitud.archivo.size > 0
        ) {
          this.mostrar_error_xml === true
            ? (this.mostrar_error_xml = false)
            : "";
          this.mostrar_cargar = true;
          let form_file = new FormData();
          form_file.append("file", this.solicitud.archivo);
          axios
            .post(
              "https://" +
                process.env.VUE_APP_URL +
                ":3000/gastos/api/v1/archivos/analizar",
              form_file
            )
            .then((res) => {
              if(res.data.rfc_receptor!='SME980702916')
              {
                this.$refs.form.reset()
                this.texto_error = "La solicitud no fue emitida a Bollore";
                this.$emit("error","La solicitud no fue emitida a Bollore")
                this.mostrar_error_xml = true;
                this.mostrar_cargar = false
                this.is_waiting=true
                return false
              }
              
              axios
                .get(
                  `https://` +
                    process.env.VUE_APP_URL +
                    `:3000/gastos/api/v1/solicitudes/archivos/validarcfdi/${res.data.uuid}/${res.data.rfc_emisor}/${res.data.rfc_receptor}/${res.data.total}/${res.data.divisa}`
                )
                .then((validate_cfdi) => {
                  if (
                    validate_cfdi.data.status ===
                    "solictud no registrada anteriormente"
                  ) {
                    let fecha = res.data.fecha_solicitud.split("/");
                    this.solicitud.subtotal = res.data.subtotal;
                    this.solicitud.total = res.data.total;
                    this.solicitud.iva = res.data.iva;
                    this.solicitud.descripcion = res.data.descripcion;
                    this.solicitud.fecha_solicitud =
                      fecha[2] + "-" + fecha[1] + "-" + fecha[0];

                    this.fecha_formated=fecha[0]+"-"+fecha[1]+"-"+fecha[2]  
                    this.solicitud.id_divisa = res.data.id_divisa;
                    this.solicitud.id_tipo_archivo_solicitud = this.forma_solicitud;
                    this.solicitud.uuid = res.data.uuid;
                    this.solicitud.rfc_emisor = res.data.rfc_emisor;
                    this.solicitud.rfc_receptor = res.data.rfc_receptor;
                    this.solicitud.serie_xml = res.data.serie;
                    this.solicitud.numero_factura = res.data.serie+"-"+res.data.folio;
                    this.solicitud.descuento =
                      res.data.descuento != undefined ? res.data.descuento : 0;
                    this.solicitud.otrosimpuestos =
                      res.data.otrosimpuestos != undefined
                        ? res.data.otrosimpuestos
                        : 0;
                    this.solicitud.totalImpuestosTraslados =
                      res.data.totalImpuestosTraslados != undefined
                        ? res.data.totalImpuestosTraslados
                        : 0;
                  } else {
                    this.$refs.form.reset()
                    this.fecha_formated=""
                    this.texto_error = validate_cfdi.data.status;
                    this.$emit("error",validate_cfdi.data.status)
                    this.mostrar_error_xml = true;
                   
                  }
                  this.mostrar_cargar = false;
                }).catch(()=>{
                  this.fecha_formated=""
                  this.mostrar_cargar = false;
                  this.mostrar_error_xml = true;
                  this.texto_error = "Error consultando el estatus de factura"
                  this.$emit("error","Error consultando el estatus de factura")
                });
            });
        } else {
          if (this.mostrar_error_xml === true) {
            this.mostrar_error_xml = false;
          }
          if (this.mostrar_cargar === true) {
            this.mostrar_cargar = false;
          }
          this.solicitud.fecha_solicitud = "";
          this.fecha_formated= "";
          this.solicitud.total = "";
          this.solicitud.id_divisa = null;
          this.solicitud.descripcion = "";
        }
      } else {
        if (this.mostrar_error_xml === true) {
          this.mostrar_error_xml = false;
        }
        if (this.solicitud.fecha_solicitud !== "") {
          this.reset();
        }
        if (this.mostrar_cargar === true) {
          this.mostrar_cargar = false;
        }
      }
    }
     catch (error) {
                null
            }
        },
        submit_xml: function(){
          this.mostrar_alerta = false;
          if (this.$refs.form.validate()) {
            this.is_waiting = true;
            this.solicitud.id_tipo_solicitud = 2;
            this.solicitud.id_locacion_solicitud = 1;
            this.solicitud.id_forma_solicitud = 1;
            this.solicitud.monto_cambio = 0.0;
            //this.solicitud.numero_factura = ""; para agregar numero_factura
            this.solicitud.id_deudor=this.deudor;
            /*
            if (this.propina) {
              this.solicitud.propina = parseFloat(this.solicitud.total*0.10).toFixed(2);
            }
            */
            //let solicitud = this.create_formdata_solicitud(this.solicitud);
            return this.solicitud
          }
        },
        show_anexo_form: function(){
            try {
                var obj_selected = this.cuentas.filter((obj) => {
                  return obj.id_cuenta === this.solicitud.id_cuenta;
                });
                if (obj_selected[0]["requiere_anexo"] === true) {
                  this.propina = true;
                } else {
                  this.propina = false;
                }
                if (obj_selected[0]["es_anexo_comida"] === true) {
                  this.descripcion_propina = true;
                } else {
                  this.descripcion_propina = false;
                }
                if (obj_selected[0]["requiere_descripcion"] === true) {
                  this.requiere_descripcion = true;
                } else {
                  this.requiere_descripcion = false;
                }

                this.propina_column=this.propina
                this.$emit("updated")
            } catch (error) {
                null
            }
        },
        necesita_propina: function(){
            try {

                var obj_selected = this.cuentas.filter((obj) => {
                  return obj.id_cuenta === this.solicitud_sin_factura.id_cuenta;
                });
                if (obj_selected[0]["requiere_anexo"] === true) {
                  this.propina_pdf = true;
                } else {
                  this.propina_pdf = false;
                }
                if (obj_selected[0]["es_anexo_comida"] === true) {
                  this.descripcion_propina_pdf = true;
                } else {
                  this.descripcion_propina_pdf = false;
                }
                if (obj_selected[0]["requiere_descripcion"] === true) {
                  this.requiere_descripcion_pdf = true;
                } else {
                  this.requiere_descripcion_pdf = false;
                }

                this.propina_column=this.propina_pdf
                this.$emit("updated")
            } catch (error) {
                null
            }
        },
        create_formdata_solicitud(solicitud) {
          let dataform_solicitud = new FormData();
          dataform_solicitud.append("file", solicitud.archivo);
          dataform_solicitud.append("file_anexo_cfdi", solicitud.anexo_cfdi);
          dataform_solicitud.append("id_deudor", solicitud.id_deudor);
          dataform_solicitud.append("id_deudor_original", this.id_deudor_original);
          dataform_solicitud.append("total", solicitud.total);
          if (solicitud.id_tipo_solicitud === 2) {
            dataform_solicitud.append("fecha_solicitud", solicitud.fecha_solicitud);
          } else {
            let fecha_format = solicitud.fecha_solicitud.split("/");
            dataform_solicitud.append(
              "fecha_solicitud",
              fecha_format[2] + "-" + fecha_format[1] + "-" + fecha_format[0]
            );
          }
          dataform_solicitud.append(
            "id_tipo_solicitud",
            solicitud.id_tipo_solicitud
          );
          dataform_solicitud.append("descripcion", solicitud.descripcion);
          dataform_solicitud.append("subtotal", solicitud.subtotal);
          dataform_solicitud.append("iva", solicitud.iva);
          dataform_solicitud.append("id_divisa", solicitud.id_divisa);
          dataform_solicitud.append("id_cuenta", solicitud.id_cuenta);
          dataform_solicitud.append("anexo", solicitud.archivo_propina);
          dataform_solicitud.append(
            "id_locacion_solicitud",
            this.locacion_solicitud
          );
          dataform_solicitud.append(
            "id_tipo_archivo_solicitud",
            solicitud.id_tipo_archivo_solicitud
          );
          dataform_solicitud.append("deudor", this.deudor);
          dataform_solicitud.append("propina", solicitud.propina);
          dataform_solicitud.append("uuid", solicitud.uuid);
          dataform_solicitud.append("rfc_emisor", solicitud.rfc_emisor);
          dataform_solicitud.append("rfc_receptor", solicitud.rfc_receptor);
          dataform_solicitud.append("monto_cambio", solicitud.monto_cambio);
          dataform_solicitud.append(
            "descripcion_propina",
            solicitud.descripcion_propina
          );
          dataform_solicitud.append(
            "comensales_propina",
            solicitud.comensales_propina
          );
          dataform_solicitud.append(
            "id_forma_solicitud",
            solicitud.id_forma_solicitud
          );
          dataform_solicitud.append("numero_factura", solicitud.numero_factura);
          dataform_solicitud.append("serie_xml", solicitud.serie_xml);
          dataform_solicitud.append("comentarios", solicitud.comentarios);
          dataform_solicitud.append("id_grupo", solicitud.id_grupo);
          dataform_solicitud.append("descuento", solicitud.descuento);
          dataform_solicitud.append("otrosimpuestos", solicitud.otrosimpuestos);
          dataform_solicitud.append(
            "totalImpuestosTraslados",
            solicitud.totalImpuestosTraslados
          );
          return dataform_solicitud;
        },
        submit_pdf() {
          this.mostrar_alerta = false;
          if (this.$refs.form_pdf.validate()) {
            this.is_waiting = true;
            this.solicitud_sin_factura.id_tipo_solicitud = 2;
            this.solicitud_sin_factura.id_forma_solicitud = 2;
            this.solicitud_sin_factura.descuento = 0;
            this.solicitud_sin_factura.id_deudor = this.deudor;
            this.solicitud_sin_factura.id_deudor_original = this.deudor;
            this.solicitud_sin_factura.otrosimpuestos = 0;
            this.solicitud_sin_factura.totalImpuestosTraslados = 0;
            this.solicitud.id_locacion_solicitud = 1;
            var iva = parseFloat(
              parseFloat(this.solicitud_sin_factura.total) * 0.16
            );
            var subtotal = parseFloat(this.solicitud_sin_factura.total) - iva;
            iva = iva.toFixed(2);
            subtotal = subtotal.toFixed(2);
            /*
            if (this.propina_pdf===true) {
              this.solicitud_sin_factura.propina = parseFloat(this.solicitud_sin_factura.total*0.10).toFixed(2);
            }
            */
            this.solicitud_sin_factura.iva = iva;
            this.solicitud_sin_factura.subtotal = subtotal;
            this.solicitud_sin_factura.id_tipo_archivo_solicitud = 2;
            // const solicitud = this.create_formdata_solicitud(
            //   this.solicitud_sin_factura
            // );

            /*
            axios
              .post(
                "https://" +
                  process.env.VUE_APP_URL +
                  ":3000/gastos/api/v1/solicitudes",
                solicitud
              )
              .then(() => {
                this.reset_pdf();
                this.mostrar_alerta = true;
              });
              */
              
              return this.solicitud_sin_factura
            }
        },
        update_exchange: function(){
          if(this.solicitud_sin_factura.id_divisa!==undefined && this.solicitud_sin_factura.id_divisa!=45)
          {
            this.foreign_ex=true
          }else{
            this.foreign_ex=false
          }

          this.$emit("updated")
        },
        reset() {
      this.$refs.form.reset();
      this.mostrar_cargar = false;
      this.propina = false;
      this.descripcion_propina = false;
      this.requiere_descripcion = false;
      this.is_waiting = false;
      this.propina_column=false
    },
    reset_pdf() {
      this.$refs.form_pdf.reset();
      this.propina_column=false
      this.propina_pdf = false;
      this.descripcion_propina_pdf = false;
      this.requiere_descripcion_pdf = false;
      this.is_waiting = false;
    },
    },
    computed:{
      sin_fecha_formated: function (){

        if(this.solicitud_sin_factura.fecha_solicitud!==undefined && this.solicitud_sin_factura.fecha_solicitud!=='')
        {
          const arre=this.solicitud_sin_factura.fecha_solicitud.split("-")
          return arre[2]+'-'+arre[1]+'-'+arre[0]
        }else{
          return ""
        }
      }
    }
}
</script>
<style>
.form{
  display: contents;
}

.row-red{
  background-color:tomato !important;
}

.void{
  background: repeating-linear-gradient(
  45deg,
  silver,
  silver 5px,
  white 5px,
  white 10px
);
}

.row-number .opt-hover{
  display: none;
  border-radius: 50rem;
  background-color: red;
}

.row-number:hover .opt-hover{
  z-index: 999;
  display:flow-root;
  float: left;
  cursor: pointer;
  font-size: 1rem;
  font-weight: bolder;
  position: absolute;
  margin-top : -1rem;
  margin-left : 2rem;
  text-align: center;
  padding-top: 0.2rem;
  width: 2rem;
  height: 2rem;
}

</style>